import React, { Component } from "react";
import TeamMember from "../common/TeamMember";
import TeamMemberInvite from "../common/TeamMemberInvite";
import { Router, Route, NavLink } from "react-router-dom";
import { createBrowserHistory, createHashHistory } from "history";
import ManageMember from "./ManageMember";
import { Shimmer } from "react-shimmer";
import API from "../common/Api";
import { connect } from "react-redux";

const history = createBrowserHistory();
const mapStateToProps = (state) => ({
  headers: state.headers(),
});

export default connect(mapStateToProps)(
  class TeamMembers extends Component {
    state = {};
    getTeam = () => {
      API.get("business/teams", { headers: this.props.headers }).then(
        ({ data }) => {
          const pending_invites = data.data.pending_invites;
          const team_members = data.data.team_members;
          this.setState({
            pending_invites: undefined,
            team_members: undefined,
          });
          this.setState({ pending_invites, team_members });
        }
      );
    };
    componentDidMount = () => {
      this.getTeam();
    };
    render() {
      return (
        <>
          <div className="wrapper team-page">
            <div className="header flex space-btw">
              <h1 className="title">Team members</h1>
              <NavLink to={{ pathname: "/invite" }} className="co-pink">
                Invite team members
              </NavLink>
            </div>
            {/* <Loader /> */}
            <div className="layout-grid">
              <div className="card">
                <p className="title">Pending requests</p>

                {this.state.pending_invites ? (
                  this.state.pending_invites.length > 0 ? (
                    this.state.pending_invites.map((invite) => (
                      <TeamMemberInvite
                        data={invite}
                        refresh={() => {
                          this.getTeam();
                        }}
                      />
                    ))
                  ) : (
                    <>
                      <br />
                      <p className="off">"There is no pending request to join your team"</p>
                    </>
                  )
                ) : (
                  <Loader />
                )}
              </div>

              <div className="card">
                <p className="title">Manage team members</p>
                {this.state.team_members ? (
                  this.state.team_members.length > 0 ? (
                    this.state.team_members
                      .filter((member) => !member.deleted_at)
                      .map((member) => (
                        <TeamMember data={member} />
                      ))
                  ) : (
                    <>
                      <br />
                      <p className="off">"Team members haven’t been added."</p>
                    </>
                  )
                ) : (
                  <Loader />
                )}
              </div>
            </div>
            {/* convert to modal on desktop */}
            {window.innerWidth >= 600 ? (

                <Route

                path="/team/:member_uuid/member"
                  component={ManageMember}
              />
            ) : (
              ""
            )}
          </div>
        </>
      );
    }
  }
);

function Loader() {
  return (
    <>
      <br />
      <Shimmer
        width={window.innerWidth - 32}
        height={60}
        className="shimmerLoader r-shimer-service"
      />
      <Shimmer
        width={window.innerWidth - 32}
        height={60}
        className="shimmerLoader r-shimer-service"
      />
    </>
  );
}
